import '@babel/polyfill';
// Vue
import Vue from 'vue';
import App from './App';

// 解决bug：页面/路由跳转后，滚动条消失，页面无法滚动
router.afterEach((to, from, next) => {
    document.querySelector("body").setAttribute("style", "overflow: auto !important;")
});

// 配置
import Setting from './setting';

// 混合
import mixinApp from '@/mixins/app';

// 插件
import plugins from '@/plugins';

// store
import store from '@/store/index';

// iView 和 iView Pro
import ViewUI from 'view-design';
import iViewPro from '@/libs/iview-pro/iview-pro.min.js';
import moment from 'moment';
Vue.prototype.moment  =  moment;
// 菜单和路由
import router from './router';
import menuHeader from '@/menu/header';
import menuSider from '@/menu/sider';
import { frameInRoutes } from '@/router/routes';

// 多语言
import i18n from '@/i18n';

// 方法
import { getHeaderName, getMenuSider, getSiderSubmenu } from '@/libs/system';

// 内置组件
import iLink from '@/components/link';
import iFrame from '@/components/frame';

// jsonp跨域支持
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)

// 多功能导航菜单
/*import iSidebar from '@/components/sidebar/sidebar.min.js';
Vue.use(iSidebar);*/

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme
import './styles/index.less';
import './libs/iview-pro/iview-pro.css';

// 引入AgileBPM 自身的组件
import AbGlobalComponents from '@/components/ab-global-components'
Vue.use(AbGlobalComponents);

if (window) window.$t = (key, value) => i18n.t(key, value);

if(window) window.$abT = function(key){
	if (key && key.indexOf('$t:') === 0) {
        return $t(key.split('$t:')[1]);
    } else {
        return key;
    }
}
Vue.prototype.$abT = $abT;

Vue.use(plugins);

Vue.use(ViewUI, {
	size: 'small',
    i18n: (key, value) => i18n.t(key, value)
});
Vue.use(iViewPro);
Vue.component('i-link', iLink);
Vue.component('i-frame', iFrame);

//数据字典管理
import sysDictMange from '@/libs/sysDictMange.js';
Vue.prototype.$dict  =  sysDictMange;

new Vue({
    mixins: [mixinApp],
    router,
    store,
    i18n,
    render: h => h(App),
    created () {
        // 处理路由 得到每一级的路由设置
        this.$store.commit('admin/page/init', frameInRoutes);
        // 设置顶栏菜单
        this.$store.commit('admin/menu/setHeader', menuHeader);
        // 加载用户登录的数据
        this.$store.dispatch('admin/account/load');
        // 初始化全屏监听
        this.$store.dispatch('admin/layout/listenFullscreen');

		// 国际化处理，先拿上次缓存的
        this.$store.dispatch('admin/db/database').then((db)=>{
        	const internation = db.get('internation').value();
        	if(internation){
        		for(var key in internation){
        			i18n.mergeLocaleMessage(key,internation[key]);
        		}
        	}
        	
        	let post = Vue.abHttpUtil.postForm("/sys/sysInternation/getJs" , {});
        	Vue.abTools.getResultData(post,data=>{
        		for(var key in data){
        			i18n.mergeLocaleMessage(key,data[key]);
        		}
        		db.set('internation', data).write();
        	});
        })
    },
    watch: {
        // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
        '$route' (to, from) {
            let path = to.matched[to.matched.length - 1].path;
            if (!Setting.dynamicSiderMenu) {
                let headerName = getHeaderName(path, menuSider);
                if (headerName === null) {
                    path = to.path;
                    headerName = getHeaderName(path, menuSider);
                }
                // 在 404 时，是没有 headerName 的
                if (headerName !== null) {
                    this.$store.commit('admin/menu/setHeaderName', headerName);
                    this.$store.commit('admin/menu/setMenuSider', menuSider);

                    const filterMenuSider = getMenuSider(menuSider, headerName);
                    this.$store.commit('admin/menu/setSider', filterMenuSider);
                    this.$store.commit('admin/menu/setActivePath', to.fullPath);
                    const openNames = getSiderSubmenu(path, menuSider);
                    this.$store.commit('admin/menu/setOpenNames', openNames);
                }
            }
            this.appRouteChange(to, from);
        }
    }
}).$mount('#app');
